import './plugins/firebase'

import Vue from 'vue'
import App from './App.vue'
import './plugins/element'

import router from './router/index'
import store from '@/store'


import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: 'https://bf37a427848d40baab0e382383a4a89c@sentry.io/1542083',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
});

import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
// Use Sentry Error Logging

// Raven
//   .config('https://74f0dba173384471b8f39908542b51a8@sentry.io/1427335')
//   .addPlugin(RavenVue, Vue)
//   .install();

// Vue.use(VueChartkick, { adapter: Chart })
// Vue.use(VueFire)

Vue.config.productionTip = false

//Global component import


// const firebaseApp = firebase.initializeApp({
//   apiKey: "AIzaSyDvvTN1ADpF59UTYjkUtgt8ThPFUTWQf7I",
//   authDomain: "pronaid-admin.firebaseapp.com",
//   databaseURL: "https://pronaid-admin.firebaseio.com",
//   projectId: "pronaid-admin",
//   storageBucket: "pronaid-admin.appspot.com",
//   messagingSenderId: "948685408457"
// });


store.dispatch('auth/init').then(() => {
  new Vue({
    components: { App },
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})